"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function stripSymbols(data) {
    return JSON.parse(JSON.stringify(data));
}
exports.stripSymbols = stripSymbols;
//# sourceMappingURL=stripSymbols.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/apollo-utilities/lib/util/stripSymbols.js
// module id = iiDM
// module chunks = 25